import { useMediaQuery } from '@vueuse/core';

import type { Ref } from 'vue';

export interface UseBreakpointsResult {
  isMobile: Ref<boolean>;
  showFacetSideBar: Ref<boolean>;
}

export function useBreakpoints(): UseBreakpointsResult {
  const isMobile = useMediaQuery('(max-width: 767px)');
  const showFacetSideBar = useMediaQuery('(min-width: 992px)');

  return { isMobile, showFacetSideBar };
}
